export const typesIdentification = [  
    { id: "CC", value: "Cédula de ciudadania" },
    { id: "CE", value: "Cédula extranjero" },
  ];

  export const servicesURl = [  
    { id: "EVENTOS_GEI", value: "Eventos GEI" },
    { id: "PORTAFOLIO", value: "Portafolio" },
    { id: "RESULTADOS_GEI", value: "Resultados GEI" },
  ];

  export const typesReportFrequency = [  
    { id: "TRIMESTRAL", value: "TRIMESTRAL" },
    { id: "SEMESTRAL,", value: "SEMESTRAL," },
    { id: "ANUAL,", value: "ANUAL," },
  ];

  export const typesReportUse = [  
    { id: "USO INTERNO", value: "USO INTERNO" },
    { id: "DIVULGACIÓN PÚBLICA", value: "DIVULGACIÓN PÚBLICA" },
  ];

  export const typesoOrganizationalLimits = [  
    { id: "ENFOQUE DE PARTICIPACIÓN ACCIONARIA", value: "ENFOQUE DE PARTICIPACIÓN ACCIONARIA" },
    { id: "ENFOQUE DE CONTROL FINANCIERO", value: "ENFOQUE DE CONTROL FINANCIERO," },
    { id: "ENFOQUE DE CONTROL OPERACIONAL", value: "ENFOQUE DE CONTROL OPERACIONAL," },
  ];

  export const typesoOperationalsLimits = [  
    { id: "1", value: "1" },
    { id: "2", value: "2" },
    { id: "3", value: "3" },
    { id: "4", value: "4" },
    { id: "5", value: "5" },
    { id: "6", value: "6" },
  ];

  export const typesoGeiLimits = [  
    { id: "CO2", value: "CO2" },
    { id: "CH4", value: "CH4" },
    { id: "N2O", value: "N2O" },
    { id: "HFCs", value: "HFCs" },
    { id: "SF6", value: " SF6" },
    { id: "HCFCS", value: "HCFCS" }    
  ];

  export const listMonths = [  
    { id: "ene", value: "Enero" },
    { id: "feb", value: "Febrero" },
    { id: "mar", value: "Marzo" },
    { id: "abr", value: "Abril" },
    { id: "may", value: "Mayo" },
    { id: "jun", value: "Junio" },
    { id: "jul", value: "Julio" },
    { id: "ago", value: "Agosto" },   
    { id: "sep", value: "Septiembre" },   
    { id: "oct", value: "Octubre" },  
    { id: "nov", value: "Noviembre" },   
    { id: "dic", value: "Diciembre" }, 
    { id: "annual", value: "Anual" }       
  ];

